import React from "react";
import styled from "styled-components";
import { getIconName, iconName } from "../icons/Icons";
import { ButtonHover, ButtonSize, ButtonStyle, ButtonVariant, IconWrapper } from "./Shared";
import { TooltipTheOneWrapper } from "../TooltipTheOne";


type ButtonType = 'button' | 'submit' | 'reset';


export type ButtonProps = {
    disabled?: boolean;
    heightOverride?: string; //later combine stretch and number?
    icon?: iconName;
    iconPosition?: 'left' | 'right';
    innerRef?:React.Ref<HTMLButtonElement>;
    text?: string;
    titleText?: string;
    tooltipContent?:React.ReactNode;
    toolTipText?:string;
    tooltipHorizontalAlignment?: 'left' | 'right';
    type?:ButtonType;
    variant:ButtonVariant;
    size?:ButtonSize;
    dataCy?:string;
    ariaLabel?:string;
    onClick?:React.MouseEventHandler<HTMLButtonElement>
}


export function Button(props: ButtonProps){

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            props.onClick && props.onClick(event);  // Trigger the onClick function when Enter is pressed and pass the event object as an argument
        }
      };

    const btn =
        <StyledButton
            data-cy={props.dataCy}
            onKeyDown={handleKeyDown}
            title={props.titleText}
            ref={props.innerRef}
            variant={props.variant}
            heightOverride={props.heightOverride}
            icon={props.icon}
            iconPosition={props.iconPosition}
            disabled={props.disabled}
            size={props.size}
            aria-label={props.ariaLabel}
            onClick={ (e) => props.onClick!=undefined && props.onClick(e)}>
            {props.icon && (
                <IconWrapper variant={props.variant} hasText={props.text ? true : false}>{getIconName(props.icon)}</IconWrapper>
            )}
            {props.text && (
                <span>{props.text}</span>
            )}
            <ButtonHover variant={props.variant}></ButtonHover>
        </StyledButton>;

    return (
        <>
            {props.tooltipContent 
                ?   <TooltipTheOneWrapper tooltipContent={props.tooltipContent} horizontalAlignment={props.tooltipHorizontalAlignment}>
                        {btn}
                    </TooltipTheOneWrapper>
                : props.toolTipText 
                    ?   <TooltipTheOneWrapper tooltipContent={props.toolTipText} horizontalAlignment={props.tooltipHorizontalAlignment}>
                            {btn}
                        </TooltipTheOneWrapper>
                    : btn
            }
        </>
    );
}


const StyledButton = styled.button<{ variant: ButtonVariant, size?:ButtonSize, icon?: iconName, heightOverride?:string, iconPosition?: string }>`
    ${ButtonStyle}
`;